const state = {
    blood_types:[
        {text:"A+",value:1}, {text:"A-",value:2}, {text:"B+",value:3}, {text:"B-",value:4},
        {text:"AB+",value:5}, {text:"AB-",value:6}, {text:"O+",value:7}, {text:"O-",value:8}, 
      ],
      genders : [{
        text:"Male",
        value:1,
        icon:"mdi-gender-male"
      },
      {
        text:"Female",
        value:2,
        icon:"mdi-gender-female"
      }],
      geofencing_types:[{'text':'Circle','value':1},{'text':'Rectangle','value':2},{'text':'Square','value':3},{'text':'Custom','value':4}],
      media_object_types:{
        profile_picture:{'text':'Profile Picture','value':1}, 
        image:{'text':'Image','value':2}, 
        video:{'text':'Video','value':3}, 
        document:{'text':'Document','value':4}
      },
      waybill_statuses:[{'text':'Idle','value':1}, {'text':'Started','value':2}, {'text':'Stopped','value':3}, {'text':'Waiting','value':4}],
      user_roles :[{'text':'Administrator','value':1}, {'text':'Editor','value':2}, {'text':'Client','value':3}]
}

export default {
    namespaced: true,
    state,
  }
  